import { Action } from "redux";
import { DELETE, update } from "immupdate";
import { PersistConfig } from "redux-persist";
import { AppStoreState } from "../store/RootReducer";
import { createReducer, createRootReducer, PerformAction } from "../utils/ReducerUtils";
import { userInfo } from "../api/auth/AuthDTO";

export const userReducerPersistConfig: Partial<PersistConfig<UserReducerState>> = {
  whitelist: ["userId", "dcId", "position", "userInformation", "exclusions"],
};

interface SetUserMeta {
  readonly userId: string;
}
interface SetUserTableColumnPositionMeta {
  readonly position: any;
}
interface SetDcIdMeta {
  readonly dcId: string;
}
interface SetUserInformationMeta {
  readonly userInformation: userInfo;
}
interface SetUserTableColumnExclusionsMeta {
  readonly exclusions: any[];
}

enum ReducerActions {
  SetUserId = "User/SetUserId",
  ClearUserId = "User/ClearUserId",
  SetDcId = "User/SetDcId",
  ClearDcId = "User/ClearDcId",
  SetUserTableColumnPosition = "User/SetUserTableColumnPosition",
  ClearUserTableColumnPosition = "User/ClearUserTableColumnPosition",
  SetUserInformation = "User/SetUserInformation",
  SetUserTableColumnExclusions = "User/SetUserTableColumnExclusions",
}

export interface UserReducerState {
  readonly userId?: string;
  readonly dcId?: string;
  readonly currentPosition?: any;
  readonly position?: any;
  readonly exclusions: any;
  readonly userInformation?: userInfo;
}

function getState(): UserReducerState {
  return {
    exclusions: [],
  };
}

export const userReducer = createRootReducer<UserReducerState>(
  getState(),

  createReducer([ReducerActions.SetUserId], (state, { meta }) =>
    update(state, { userId: meta.userId }),
  ),

  createReducer([ReducerActions.ClearUserId], (state) => update(state, { userId: DELETE })),

  createReducer([ReducerActions.SetDcId], (state, { meta }) => update(state, { dcId: meta.dcId })),

  createReducer([ReducerActions.ClearDcId], (state) => update(state, { dcId: DELETE })),

  createReducer([ReducerActions.SetUserTableColumnPosition], (state, { meta }) =>
    update(state, { position: meta.position }),
  ),

  createReducer([ReducerActions.ClearUserTableColumnPosition], (state) =>
    update(state, { position: DELETE }),
  ),
  createReducer([ReducerActions.SetUserInformation], (state, { meta }) =>
    update(state, { userInformation: meta.userInformation }),
  ),
  createReducer([ReducerActions.SetUserTableColumnExclusions], (state, { meta }) =>
    update(state, { exclusions: meta.exclusions }),
  ),
);

// ==================
// Selectors
// ==================

export const userSelector = ({ user }: AppStoreState): string | undefined | any => user?.userId;

export const dcIdSelector = ({ user }: AppStoreState): string | undefined | any => user?.dcId;

export const userTableColumnPositionSelector = ({
  user,
}: AppStoreState): string | undefined | any => user?.position;

export const userInformationSelector = ({ user }: AppStoreState): userInfo | undefined =>
  user?.userInformation;
export const userTableColumnExclusionsSelector = ({
  user,
}: AppStoreState): string | undefined | any => user?.exclusions;

// export const userIdSelector = ({ user }: AppStoreState): string | undefined => user.user?.id;
//
// export const userFirstNameSelector = ({ user }: AppStoreState): string | undefined =>
//   user.user?.first_name;
//
// export const userLastNameSelector = ({ user }: AppStoreState): string | undefined =>
//   user.user?.last_name;
// ==================
// Actions
// ==================

export function setUser(meta: SetUserMeta): PerformAction<SetUserMeta> {
  return { type: ReducerActions.SetUserId, meta };
}

export function clearUser(): Action {
  return { type: ReducerActions.ClearUserId };
}

export function setUserTablePosition(
  meta: SetUserTableColumnPositionMeta,
): PerformAction<SetUserTableColumnPositionMeta> {
  return { type: ReducerActions.SetUserTableColumnPosition, meta };
}
export function clearUserTablePosition(): Action {
  return { type: ReducerActions.ClearUserTableColumnPosition };
}

export function setUserTableExclusions(
  meta: SetUserTableColumnExclusionsMeta,
): PerformAction<SetUserTableColumnExclusionsMeta> {
  return { type: ReducerActions.SetUserTableColumnExclusions, meta };
}

export function setDcId(meta: SetDcIdMeta): PerformAction<SetDcIdMeta> {
  return { type: ReducerActions.SetDcId, meta };
}

export function clearDcId(): Action {
  return { type: ReducerActions.ClearDcId };
}

export function setUserInformation(
  meta: SetUserInformationMeta,
): PerformAction<SetUserInformationMeta> {
  return { type: ReducerActions.SetUserInformation, meta };
}
